import {
    SHAREHOLDERS_INFORMATION,
    STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION,
    FINANCIAL_INFORMATION,
    MEANS_THROUGH_WHICH_USERS_GAIN_ACCESS_TO_SBO_NETWORK,
    COLLECTION_OF_PAYMENT,
    DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED,
    COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES,
    SYSTEM_CONFIGURATION_AND_OPERATION,
    TELECOMMUNICATION_PARTNERS,
    INTERNATIONAL_GATEWAYS,
    INFORMATION_OF_BOARD_OF_DIRECTORS_CEO,
    INFORMATION_OF_BOARD_OF_DIRECTORS_CEO_FROM_EDH_ACRA,
    OTHER_TECHNICAL_SUPPORT,
    NUMBERING_REQUIREMENT,
    PUBLIC_INTERNET_ACCESS_SERVICES,
    REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES,
    PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID,
    PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID,
    OTHERS_SERVICES,
    REGISTRATION_FOR_OTHER_SERVICES,
    OTHER_SERVICES_NON_PREPAID,
    OTHER_SERVICES_PREPAID,
    RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES,
    REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES,
    RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID,
    RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID,
    INTERNATIONAL_CALLING_CARD_SERVICES,
    REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES,
    INTERNATIONAL_CALLING_CARD_SERVICES_PREPAID,
    SUPPORTING_DOCUMENTS,
    WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES,
    REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES,
    WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES_PREPAID,
    IP_TELEPHONY_SERVICES,
    REGISTRATION_FOR_IP_TELEPHONY_SERVICES,
    IP_TELEPHONY_SERVICES_NON_PREPAID,
    IP_TELEPHONY_SERVICES_PREPAID,
    VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_SERVICES,
    REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY,
    VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_PREPAID,
    MACHINE_TO_MACHINE_SERVICES,
    REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES,
    MACHINE_TO_MACHINE_NON_PREPAID,
    MACHINE_TO_MACHINE_PREPAID,
    INTERNET_BASED_VOICE_AND_DATA_SERVICES,
    REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES,
    INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID,
    INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID,
    INTERNATIONAL_SIMPLE_RESALE_SERVICES,
    REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES,
    INTERNATIONAL_SIMPLE_RESALE_SERVICES_NON_PREPAID,
    INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID,
    INTERNET_EXCHANGE_SERVICES,
    REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES,
    INTERNET_EXCHANGE_SERVICES_NON_PREPAID,
    INTERNET_EXCHANGE_SERVICES_PREPAID,
    CALL_BACK_CALL_RE_ORIGINATION_SERVICES,
    REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES,
    CALL_BACK_CALL_RE_ORIGINATION_SERVICES_PREPAID,
    STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES,
    REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES,
    STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES_PREPAID,
    STORE_AND_FORWARD_VALUE_ADDED_SERVICES,
    REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES,
    STORE_AND_FORWARD_VALUE_ADDED_SERVICES_PREPAID,
    SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES,
    REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES,
    SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES_PREPAID,
    RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES,
    REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES,
    RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES_PREPAID,
    VIRTUAL_PRIVATE_NETWORK_SERVICES,
    REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES,
    VIRTUAL_PRIVATE_NETWORK_SERVICES_NON_PREPAID,
    VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID,
    LIVE_AUDIOTEX_SERVICES,
    REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES,
    LIVE_AUDIOTEX_SERVICES_PREPAID,
    MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES,
    REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES,
    MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID,
    MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID,
    MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES,
    REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES,
    MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES_PREPAID,
    MANAGED_DATA_NETWORK_SERVICES,
    REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES,
    MANAGED_DATA_NETWORK_SERVICES_NON_PREPAID,
    MANAGED_DATA_NETWORK_SERVICES_PREPAID,
    NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES,
    REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES
} from 'common/application.const/Licence/MyApplication/SBOIApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

const mapShareholdersInformation = (licenceDetails: any) => {
    if (licenceDetails && licenceDetails.shareholderSInformation && licenceDetails.shareholderSInformation.length > 0) {
        return licenceDetails?.shareholderSInformation.map((value: any, i: number) => ({
            no: (i + 1).toString(),
            'id-no': value?.shareholders?.idNumber ?? '-',
            'id-type': value?.shareholders?.idType ?? '-',
            name: value?.shareholders?.name ?? '-',
            nationality: value?.shareholders.NationalityJSON ?? '-',
            addresss: (() => {
                const address = value?.shareholders?.address;
            
                if (!address || Object.keys(address).filter(key => key !== 'pxObjClass').length === 0) {
                    return '-';
                }
            
                const blockNo = address.blockNo ?? '';
                const streetName = address.streetName ?? '';
                const unit = address.unit ?? '';
                const floor = address.floor ?? '';
                const postalCode = address.postalCode ?? '';
            
                return `${blockNo} ${streetName}, ${unit} - ${floor}, ${postalCode}`.trim();
            })()
        }));
    }
};

const mapSBONetwork = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.meansThroughWhichUsersGainAccessToSboSNetwork?.pleaseMarkTheMeansThroughWhichUsersGainAccessToSboSNetwork &&
        licenceDetails?.meansThroughWhichUsersGainAccessToSboSNetwork?.pleaseMarkTheMeansThroughWhichUsersGainAccessToSboSNetwork.length > 0
    ) {
        return licenceDetails?.meansThroughWhichUsersGainAccessToSboSNetwork?.pleaseMarkTheMeansThroughWhichUsersGainAccessToSboSNetwork?.map(
            (i: any) => i.mixedValue
        );
    }
};

const mapTargetCustomers = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.descriptionOfProposedServiceAndMarketServed?.targetCustomers &&
        licenceDetails?.descriptionOfProposedServiceAndMarketServed?.targetCustomers.length > 0
    ) {
        return licenceDetails?.descriptionOfProposedServiceAndMarketServed?.targetCustomers?.map((i: any) => i.mixedValue);
    }
};

const mapBoardOfDirectors = (licenceDetails: any) => {
    if (licenceDetails && licenceDetails.informationOfBoardOfDirectorsCeo && licenceDetails.informationOfBoardOfDirectorsCeo.length > 0) {
        return licenceDetails?.informationOfBoardOfDirectorsCeo.map((value: any, i: number) => ({
            no: value?.rowId,
            designation: value?.designation ?? '-',
            'full-name': value?.fullNameBOD ?? '-',
            'identification-no': value?.identificationNumber ?? '-',
            'identification-type': value.identificationType ?? '-',
            others: value.others ?? '-',
            spr: value.singaporePermanentResident ?? '-',
            national: value.countryOfBirth ?? '-'
        }));
    }
};

const mapBoardOfDirectorsFromACRA = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails.informationOfBoardOfDirectorsCeoFromEdhAcra &&
        licenceDetails.informationOfBoardOfDirectorsCeoFromEdhAcra.length > 0
    ) {
        return licenceDetails?.informationOfBoardOfDirectorsCeoFromEdhAcra.map((value: any, i: number) => ({
            no: value?.rowId,
            'identification-no': value?.appointments?.idNumber ?? '-',
            'identification-type': value?.appointments?.idType ?? '-',
            name: value?.appointments?.name ?? '-',
            national: value?.appointments.nationality ?? '-',
            addresss: (() => {
                const address = value?.appointments?.address;
            
                if (!address || Object.keys(address).filter(key => key !== 'pxObjClass').length === 0) {
                    return '-';
                }
            
                const blockNo = address.blockNo ?? '';
                const streetName = address.streetName ?? '';
                const unit = address.unit ?? '';
                const floor = address.floor ?? '';
                const postalCode = address.postalCode ?? '';
            
                return `${blockNo} ${streetName}, ${unit} - ${floor}, ${postalCode}`.trim();
            })()
        }));
    }
};

const checkServicePlanTypeList = (services: any) => {
    if (!services) return;

    return Object.entries(services)
        .filter(([key, value]: any) => value.pySelected === 'true')
        .map(([key]) => key.replace(/([A-Z])/g, ' $1').trim());
};

const publicInternetAccessServicesPlanTypeList = (licenceDetails: any) => {
    const publicInternetAccessServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList;
    return checkServicePlanTypeList(publicInternetAccessServicesPlanType);
};

const othersServicesPlanTypePlanTypeList = (licenceDetails: any) => {
    const othersServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList;
    return checkServicePlanTypeList(othersServicesPlanType);
};

const resaleOfLocalLeaseFixedLineConnectivityServicesPlanTypeList = (licenceDetails: any) => {
    const resaleOfLocalLeaseFixedLineConnectivityServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList;
    return checkServicePlanTypeList(resaleOfLocalLeaseFixedLineConnectivityServicesPlanType);
};

const internationalCallingCardServicesPlanTypeList = (licenceDetails: any) => {
    const internationalCallingCardServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.InternationalCallingCardServices?.planTypeList;
    return checkServicePlanTypeList(internationalCallingCardServicesPlanType);
};

const whiteSpaceGeoLocationDatabaseServicesPlanTypeList = (licenceDetails: any) => {
    const whiteSpaceGeoLocationDatabaseServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.WhiteSpaceGeoLocationDatabaseServices?.planTypeList;
    return checkServicePlanTypeList(whiteSpaceGeoLocationDatabaseServicesPlanType);
};

const ipTelephonyServicesPlanTypeList = (licenceDetails: any) => {
    const ipTelephonyServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList;
    return checkServicePlanTypeList(ipTelephonyServicesPlanType);
};

const mapIPTelephonyServicesNonPrepaid = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.nonPrepaid &&
        licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.nonPrepaid.length > 0
    ) {
        return licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.nonPrepaid?.map(
            (i: any) => i.mixedValue
        );
    }
};

const mapIPTelephonyServicesPrepaid = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.prepaid &&
        licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.prepaid.length > 0
    ) {
        return licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.prepaid?.map(
            (i: any) => i.mixedValue
        );
    }
};

const voiceAndDataServicesWithMaskingOfCallingLineIdentityServicesPlanTypeList = (licenceDetails: any) => {
    const voiceAndDataServicesWithMaskingOfCallingLineIdentityServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.VoiceAndDataServicesWithMaskingOfCallingLineIdentity?.planTypeList;
    return checkServicePlanTypeList(voiceAndDataServicesWithMaskingOfCallingLineIdentityServicesPlanType);
};

const machineToMachineServicesPlanTypeList = (licenceDetails: any) => {
    const machineToMachineServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList;
    return checkServicePlanTypeList(machineToMachineServicesPlanType);
};

const internetBasedVoiceAndDataServicesPlanTypeList = (licenceDetails: any) => {
    const internetBasedVoiceAndDataServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList;
    return checkServicePlanTypeList(internetBasedVoiceAndDataServicesPlanType);
};

const internationalSimpleResaleServicesPlanTypeList = (licenceDetails: any) => {
    const internationalSimpleResaleServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList;
    return checkServicePlanTypeList(internationalSimpleResaleServicesPlanType);
};

const internetExchangeServicesPlanTypeList = (licenceDetails: any) => {
    const internetExchangeServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList;
    return checkServicePlanTypeList(internetExchangeServicesPlanType);
};

const callBackCallReOriginationServicesPlanTypeList = (licenceDetails: any) => {
    const callBackCallReOriginationServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.CallbackCallReoriginationServices?.planTypeList;
    return checkServicePlanTypeList(callBackCallReOriginationServicesPlanType);
};

const storeAndRetrieveValueAddedServicesPlanTypeList = (licenceDetails: any) => {
    const storeAndRetrieveValueAddedServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.StoreandRetrieveValueAddedNetworkServices?.planTypeList;
    return checkServicePlanTypeList(storeAndRetrieveValueAddedServicesPlanType);
};

const storeAndForwardValueAddedServicesPlanTypeList = (licenceDetails: any) => {
    const storeAndForwardValueAddedServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.StoreandForwardValueAddedNetworkServices?.planTypeList;
    return checkServicePlanTypeList(storeAndForwardValueAddedServicesPlanType);
};

const satelliteMobileTelephoneOrDataServicesPlanTypeList = (licenceDetails: any) => {
    const satelliteMobileTelephoneOrDataServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.SatelliteMobileTelephoneorDataServices?.planTypeList;
    return checkServicePlanTypeList(satelliteMobileTelephoneOrDataServicesPlanType);
};

const resaleOfPublicSwitchedTelecommunicationServicesPlanTypeList = (licenceDetails: any) => {
    const resaleOfPublicSwitchedTelecommunicationServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.ResaleofPublicSwitchedTelecommunicationServices?.planTypeList;
    return checkServicePlanTypeList(resaleOfPublicSwitchedTelecommunicationServicesPlanType);
};

const virtualPrivateNetworkServicesPlanTypeList = (licenceDetails: any) => {
    const virtualPrivateNetworkServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList;
    return checkServicePlanTypeList(virtualPrivateNetworkServicesPlanType);
};

const liveAudiotexServicesPlanTypeList = (licenceDetails: any) => {
    const liveAudiotexServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.LiveAudiotexServices?.planTypeList;
    return checkServicePlanTypeList(liveAudiotexServicesPlanType);
};

const mobileVirtualNetworkOperationServicesPlanTypeList = (licenceDetails: any) => {
    const mobileVirtualNetworkOperationServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList;
    return checkServicePlanTypeList(mobileVirtualNetworkOperationServicesPlanType);
};

const mapMobileVirtualNetworkOperationMeasureForEKYCNonPrepaid = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
            ?.measuresForEKycSolution &&
        licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid?.measuresForEKycSolution
            .length > 0
    ) {
        return licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid?.measuresForEKycSolution?.map(
            (i: any) => i.mixedValue
        );
    }
};

const mapMobileVirtualNetworkOperationMeasureForEKYCPrepaid = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid?.measuresForEKycSolution &&
        licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid?.measuresForEKycSolution
            .length > 0
    ) {
        return licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid?.measuresForEKycSolution?.map(
            (i: any) => i.mixedValue
        );
    }
};

const mobileCommunicationOnAircraftServicesPlanTypeList = (licenceDetails: any) => {
    const mobileCommunicationOnAircraftServicesPlanType =
        licenceDetails?.servicesRegistered?.servicesList?.MobileCommunicationsOnAircraft?.planTypeList;
    return checkServicePlanTypeList(mobileCommunicationOnAircraftServicesPlanType);
};

const managedDataNetworktServicesPlanTypeList = (licenceDetails: any) => {
    const managedDataNetworktServicesPlanType = licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList;
    return checkServicePlanTypeList(managedDataNetworktServicesPlanType);
};

const mapManagedDataNetworkServicesIntendToProvideNonPrepaid = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.NonPrepaid
            ?.whichOfTheFollowingFeaturesDoYouIntendToProvide &&
        licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.NonPrepaid
            ?.whichOfTheFollowingFeaturesDoYouIntendToProvide.length > 0
    ) {
        return licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.NonPrepaid?.whichOfTheFollowingFeaturesDoYouIntendToProvide?.map(
            (i: any) => i.mixedValue
        );
    }
};

const mapManagedDataNetworkServicesIntendToProvidePrepaid = (licenceDetails: any) => {
    if (
        licenceDetails &&
        licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.Prepaid
            ?.whichOfTheFollowingFeaturesDoYouIntendToProvide &&
        licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.Prepaid
            ?.whichOfTheFollowingFeaturesDoYouIntendToProvide.length > 0
    ) {
        return licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.Prepaid?.whichOfTheFollowingFeaturesDoYouIntendToProvide?.map(
            (i: any) => i.mixedValue
        );
    }
};

const numberPortabilityCentralisedDatabaseServicesPlanTypeList = (licenceDetails: any) => {
    const numberPortabilityCentralisedDatabaseServicesPlanType =
        licenceDetails?.legacyServicesRegistered?.servicesList?.NumberPortabilityCentralisedDatabaseServices?.planTypeList;
    return checkServicePlanTypeList(numberPortabilityCentralisedDatabaseServicesPlanType);
};

const cancelLicence = (licenceDetails: any, application: string, docsLic: any) => {
    return {
        id: 'cancel-licence-details',
        formID: 'cancel-licence-details',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
            [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
            [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

            [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
            [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

            [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: docsLic ? docsLic : '-'
        }
    };
};

const renewLicence = (licenceDetails: any, application: string) => {
    return {
        id: 'renew-licence-details',
        formID: 'renew-licence-details',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
            [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
            [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

            [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
            [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
            [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
            [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
            [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
            [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
        }
    };
};

const amendLicence = (licenceDetails: any, application: string, docsLic: any) => {
    let shareholdersInformation = [];
    let SBOSNetwork = [];
    let targetCustomers = [];
    let boardOfDirectors = [];
    let boardOfDirectorsFromEDHACRA = [];
    let IPTelephonyServicesNonPrepaid = [];
    let IPTelephonyServicesPrepaid = [];
    let mobileVirtualNetworkOperationMeasureForEKYCNonPrepaid = [];
    let mobileVirtualNetworkOperationMeasureForEKYCPrepaid = [];
    let managedDataNetworkServicesIntendToProvideNonPrepaid = [];
    let managedDataNetworkServicesIntendToProvidePrepaid = [];

    const mapped = (
        licenceDetails?.iwantToAmend ||
        licenceDetails?.licenceDetails?.iwantToAmend ||
        licenceDetails?.iWantToUpdate ||
        licenceDetails?.licenceDetails?.iWantToUpdate ||
        licenceDetails?.amendments?.iWantTo
    )?.map((data: { [key: string]: string }) => {
        return {
            type: data.mixedValue
        };
    });

    shareholdersInformation = mapShareholdersInformation(licenceDetails);
    SBOSNetwork = mapSBONetwork(licenceDetails);
    targetCustomers = mapTargetCustomers(licenceDetails);
    boardOfDirectors = mapBoardOfDirectors(licenceDetails);
    boardOfDirectorsFromEDHACRA = mapBoardOfDirectorsFromACRA(licenceDetails);
    IPTelephonyServicesNonPrepaid = mapIPTelephonyServicesNonPrepaid(licenceDetails);
    IPTelephonyServicesPrepaid = mapIPTelephonyServicesPrepaid(licenceDetails);
    mobileVirtualNetworkOperationMeasureForEKYCNonPrepaid = mapMobileVirtualNetworkOperationMeasureForEKYCNonPrepaid(licenceDetails);
    mobileVirtualNetworkOperationMeasureForEKYCPrepaid = mapMobileVirtualNetworkOperationMeasureForEKYCPrepaid(licenceDetails);
    managedDataNetworkServicesIntendToProvideNonPrepaid = mapManagedDataNetworkServicesIntendToProvideNonPrepaid(licenceDetails);
    managedDataNetworkServicesIntendToProvidePrepaid = mapManagedDataNetworkServicesIntendToProvidePrepaid(licenceDetails);

    return {
        id: 'amend-services-based-operations-individual-licence',
        formID: 'amend-services-based-operations-individual-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${SHAREHOLDERS_INFORMATION}-amend-table`]: [...mapped],
            [`${SHAREHOLDERS_INFORMATION}-list`]: shareholdersInformation ?? [],

            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-required-information-will-be-attached`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.requiredInformationWillBeAttached ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question1 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion1PleaseProvideDetails ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question2 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion2PleaseProvideDetails ?? '-',

            [`${FINANCIAL_INFORMATION}-required-information-will-be-attached`]:
                licenceDetails?.financialInformationPAGE?.requiredInformationWillBeAttached ?? '-',
            [`${FINANCIAL_INFORMATION}-financial-details`]: licenceDetails?.financialInformationPAGE?.financialDetails ?? '-',
            [`${FINANCIAL_INFORMATION}-financial-from`]: licenceDetails?.financialInformationPAGE?.financialYearFrom ?? '-',
            [`${FINANCIAL_INFORMATION}-financial-to`]: licenceDetails?.financialInformationPAGE?.financialYearTo ?? '-',

            [`${MEANS_THROUGH_WHICH_USERS_GAIN_ACCESS_TO_SBO_NETWORK}-means-through-which-users-gain-access-to-sbos-network`]:
                SBOSNetwork ?? [],

            [`${COLLECTION_OF_PAYMENT}-collection-of-monetary-deposits-or-use-of-prepaid-cards`]:
                licenceDetails?.collectionOfPayment?.collectionOfMonetaryDepositsOrUseOfPrepaidCards ?? '-',

            [`${DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED}-please-attached-required-information`]:
                licenceDetails?.descriptionOfProposedServiceAndMarketServed?.pleaseAttachRequiredInformation ?? '-',
            [`${DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED}-proposed-service-and-market-served-details`]:
                licenceDetails?.descriptionOfProposedServiceAndMarketServed?.proposedServiceAndMarketServedDetails ?? '-',
            [`${DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED}-target-customers`]: targetCustomers ?? [],

            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-have-you-commenced-provision-operation-of-any-of-the-telecommunication-services-applied-for-in-this-application`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices
                    ?.provisioningOperationOfAnyOfTheTelecommunicationServices ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-please-state-the-date-of-commencement`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.pleaseStateTheDateOfCommencement ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-number-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.numberOfUsers ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-profile-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.profileOfUsers ?? '-',

            [`${SYSTEM_CONFIGURATION_AND_OPERATION}-required-information-will-be-attached`]:
                licenceDetails?.systemConfigurationAndOperation?.requiredInformationWillBeAttached ?? '-',

            [`${TELECOMMUNICATION_PARTNERS}-telecommunication-partners`]:
                licenceDetails?.telecommunicationPartners?.telecommunicationPartnersJSON ?? '-',

            [`${INTERNATIONAL_GATEWAYS}-international-gateways`]: licenceDetails?.internationalGateways?.internationalGatewaysJSON ?? '-',

            [`${OTHER_TECHNICAL_SUPPORT}-other-technical-support`]:
                licenceDetails?.otherTechnicalSupportPAGE?.otherTechnicalSupportJSON ?? '-',
            [`${OTHER_TECHNICAL_SUPPORT}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.otherTechnicalSupportPAGE?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${NUMBERING_REQUIREMENT}-numbering-requirement`]: licenceDetails?.numberingRequirementPAGE?.numberingRequirementJSON ?? '-',

            [`${INFORMATION_OF_BOARD_OF_DIRECTORS_CEO}-list`]: boardOfDirectors ?? [],

            [`${INFORMATION_OF_BOARD_OF_DIRECTORS_CEO_FROM_EDH_ACRA}-list`]: boardOfDirectorsFromEDHACRA ?? [],

            [`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`]:
                publicInternetAccessServicesPlanTypeList(licenceDetails) ?? [],

            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-wifi-connectivity`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.wiFiConnectivity ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-in-principal-approval`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.inPrincipleApproval ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-internet-services-company`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.internetServicesCompany ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-intention-to-charge-for-usage`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.intentionToChargeForUsage ?? '-',

            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-wifi-connectivity`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid?.wiFiConnectivity ??
                '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-in-principal-approval`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.inPrincipleApproval ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-internet-services-company`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.internetServicesCompany ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-intention-to-charge-for-usage`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.intentionToChargeForUsage ?? '-',

            [`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`]: othersServicesPlanTypePlanTypeList(licenceDetails) ?? [],

            [`${OTHER_SERVICES_NON_PREPAID}-description`]:
                licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList?.NonPrepaid?.descriptionJSON ?? '-',

            [`${OTHER_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList?.Prepaid?.hotlineEnquiryNumberForPrepaidServices ??
                '-',
            [`${OTHER_SERVICES_PREPAID}-description`]:
                licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList?.Prepaid?.descriptionJSON ?? '-',

            [`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`]:
                resaleOfLocalLeaseFixedLineConnectivityServicesPlanTypeList(licenceDetails) ?? [],

            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID}-sbo-fbo-operator`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.NonPrepaid
                    ?.sboFboOperator ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID}-do-you-intend-to-resell-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.NonPrepaid
                    ?.doYouIntendToResellDarkFibre ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID}-activation-of-iru-or-lit-international-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.NonPrepaid
                    ?.activationOfIruOrLitInternationalDarkFibre ?? '-',

            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-sbo-fbo-operator`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.sboFboOperator ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-do-you-intend-to-resell-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.doYouIntendToResellDarkFibre ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-activation-of-iru-or-lit-international-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.activationOfIruOrLitInternationalDarkFibre ?? '-',

            [`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`]:
                internationalCallingCardServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNATIONAL_CALLING_CARD_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalCallingCardServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`]:
                whiteSpaceGeoLocationDatabaseServicesPlanTypeList(licenceDetails) ?? [],

            [`${WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.WhiteSpaceGeoLocationDatabaseServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`]: ipTelephonyServicesPlanTypeList(licenceDetails) ?? [],

            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-non-prepaid`]: IPTelephonyServicesNonPrepaid ?? [],
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-non-prepaid-others`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.nonPrepaidOthers ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-party-responsible-for-the-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.partyResponsibleForTheSubscriberRecords ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-storage-of-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.storageOfSubscriberRecords ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-maintenance-party-of-the-cdrs`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.maintenancePartyOfTheCdRs ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-cdrs-storage-in-singapore`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.cdRsStorageInSingapore ??
                '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-cdrs-retention-period`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.cdRsRetentionPeriod ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-manipulation-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.manipulationOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-passing-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.passingOnOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-masking-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.maskingOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-singapore-emergency-service-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.singaporeEmergencyServiceCentres ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-authenticating-the-subscribers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.authenticatingTheSubscribers ?? '-',

            [`${IP_TELEPHONY_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-prepaid`]: IPTelephonyServicesPrepaid ?? [],
            [`${IP_TELEPHONY_SERVICES_PREPAID}-prepaid-others`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.prepaidOthers ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-party-responsible-for-the-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.partyResponsibleForTheSubscriberRecords ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-storage-of-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.storageOfSubscriberRecords ??
                '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-maintenance-party-of-the-cdrs`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.maintenancePartyOfTheCdRs ??
                '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-cdrs-storage-in-singapore`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.cdRsStorageInSingapore ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-cdrs-retention-period`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.cdRsRetentionPeriod ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-manipulation-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.manipulationOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-passing-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.passingOnOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-masking-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.maskingOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-singapore-emergency-service-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.singaporeEmergencyServiceCentres ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-authenticating-the-subscribers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.authenticatingTheSubscribers ?? '-',

            [`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`]:
                voiceAndDataServicesWithMaskingOfCallingLineIdentityServicesPlanTypeList(licenceDetails) ?? [],

            [`${VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VoiceAndDataServicesWithMaskingOfCallingLineIdentity?.planTypeList
                    ?.Prepaid?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`]: machineToMachineServicesPlanTypeList(licenceDetails) ?? [],

            [`${MACHINE_TO_MACHINE_NON_PREPAID}-m2m-sim-card-providers-name`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.m2MSimCardProviderSName ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-local-mobile-telecommunication-operators`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.localMobileTelecommunicationOperators ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-mobile-country-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.mobileCountryCode ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-mobile-network-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.mobileNetworkCode ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-international-mobile-subscriber-identifier-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.internationalMobileSubscriberIdentifierNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-mobile-station-integrated-services-digital-network-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.mobileStationIntegratedServicesDigitalNetworkNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-m2m-devices-international-mobile-equipment-identity-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.m2MDevicesInternationalMobileEquipmentIdentityNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-do-you-intend-to-provide-physical-sim-cards-or-esims-or-both`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.doYouIntendToProvidePhysicalSimCardsOrESiMsOrBoth ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-are-the-sim-cards-and-or-esims-enabled-to-allow-voice-or-voip-calls`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.areTheSimCardsAndOrESiMsEnabledToAllowVoiceOrVoIpCalls ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-are-the-sim-cards-or-esims-enabled-to-contact-singapore-emergency-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.areTheSimCardsOrESiMsEnabledToContactSingaporeEmergencyCentres ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-please-provide-the-country-that-the-m2m-data-will-be-stored-in`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.pleaseProvideTheCountryThatTheM2MDataWillBeStoredIn ?? '-',

            [`${MACHINE_TO_MACHINE_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-m2m-sim-card-providers-name`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.m2MSimCardProviderSName ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-local-mobile-telecommunication-operators`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.localMobileTelecommunicationOperators ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-mobile-country-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid?.mobileCountryCode ??
                '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-mobile-network-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid?.mobileNetworkCode ??
                '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-international-mobile-subscriber-identifier-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.internationalMobileSubscriberIdentifierNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-mobile-station-integrated-services-digital-network-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.mobileStationIntegratedServicesDigitalNetworkNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-m2m-devices-international-mobile-equipment-identity-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.m2MDevicesInternationalMobileEquipmentIdentityNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-do-you-intend-to-provide-physical-sim-cards-or-esims-or-both`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.doYouIntendToProvidePhysicalSimCardsOrESiMsOrBoth ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-are-the-sim-cards-and-or-esims-enabled-to-allow-voice-or-voip-calls`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.areTheSimCardsAndOrESiMsEnabledToAllowVoiceOrVoIpCalls ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-are-the-sim-cards-or-esims-enabled-to-contact-singapore-emergency-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.areTheSimCardsOrESiMsEnabledToContactSingaporeEmergencyCentres ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-please-provide-the-country-that-the-m2m-data-will-be-stored-in`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.pleaseProvideTheCountryThatTheM2MDataWillBeStoredIn ?? '-',

            [`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`]:
                internetBasedVoiceAndDataServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.NonPrepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-authentication-method`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.NonPrepaid
                    ?.authenticationMethod ?? '-',

            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.Prepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID}-authentication-method`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.Prepaid
                    ?.authenticationMethod ?? '-',

            [`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`]:
                internationalSimpleResaleServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNATIONAL_SIMPLE_RESALE_SERVICES_NON_PREPAID}-short-code-for-voice-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList?.NonPrepaid
                    ?.shortCodeForVoiceServices ?? '-',

            [`${INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID}-short-code-for-voice-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList?.Prepaid
                    ?.shortCodeForVoiceServices ?? '-',

            [`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`]: internetExchangeServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNET_EXCHANGE_SERVICES_NON_PREPAID}-entity-peer`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList?.NonPrepaid?.entityPeer ?? '-',

            [`${INTERNET_EXCHANGE_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${INTERNET_EXCHANGE_SERVICES_PREPAID}-entity-peer`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList?.Prepaid?.entityPeer ?? '-',

            [`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`]:
                callBackCallReOriginationServicesPlanTypeList(licenceDetails) ?? [],

            [`${CALL_BACK_CALL_RE_ORIGINATION_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.CallbackCallReoriginationServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`]:
                storeAndRetrieveValueAddedServicesPlanTypeList(licenceDetails) ?? [],

            [`${STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.StoreandRetrieveValueAddedNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`]:
                storeAndForwardValueAddedServicesPlanTypeList(licenceDetails) ?? [],

            [`${STORE_AND_FORWARD_VALUE_ADDED_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.StoreandForwardValueAddedNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`]:
                satelliteMobileTelephoneOrDataServicesPlanTypeList(licenceDetails) ?? [],

            [`${SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.SatelliteMobileTelephoneorDataServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`]:
                resaleOfPublicSwitchedTelecommunicationServicesPlanTypeList(licenceDetails) ?? [],

            [`${RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofPublicSwitchedTelecommunicationServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`]:
                virtualPrivateNetworkServicesPlanTypeList(licenceDetails) ?? [],

            [`${VIRTUAL_PRIVATE_NETWORK_SERVICES_NON_PREPAID}-vpn-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList?.NonPrepaid?.vpnServices ??
                '-',

            [`${VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID}-vpn-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList?.Prepaid?.vpnServices ?? '-',

            [`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`]: liveAudiotexServicesPlanTypeList(licenceDetails) ?? [],

            [`${LIVE_AUDIOTEX_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.LiveAudiotexServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`]:
                mobileVirtualNetworkOperationServicesPlanTypeList(licenceDetails) ?? [],

            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-name-of-mobile-virtual-network-enabler`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.nameOfMobileVirtualNetworkEnabler ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-do-you-intend-to-provide-physical-sim-cards-and-or-esims`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.doYouIntendToProvidePhysicalSimCardsAndOrESiMs ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-know-your-customer-solution`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.knowYourCustomerEKycSolution ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-measures-for-ekyc-solution`]:
                mobileVirtualNetworkOperationMeasureForEKYCNonPrepaid ?? [],
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-delivery-and-activation-processes`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.deliveryAndActivationProcesses ?? '-',

            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-name-of-mobile-virtual-network-enabler`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.nameOfMobileVirtualNetworkEnabler ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-do-you-intend-to-provide-physical-sim-cards-and-or-esims`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.doYouIntendToProvidePhysicalSimCardsAndOrESiMs ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-know-your-customer-solution`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.knowYourCustomerEKycSolution ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-measures-for-ekyc-solution`]:
                mobileVirtualNetworkOperationMeasureForEKYCPrepaid ?? [],
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-delivery-and-activation-processes`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.deliveryAndActivationProcesses ?? '-',

            [`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`]:
                mobileCommunicationOnAircraftServicesPlanTypeList(licenceDetails) ?? [],

            [`${MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileCommunicationsOnAircraft?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`]: managedDataNetworktServicesPlanTypeList(licenceDetails) ?? [],

            [`${MANAGED_DATA_NETWORK_SERVICES_NON_PREPAID}-which-of-the-following-features-do-you-intend-to-provide`]:
                managedDataNetworkServicesIntendToProvideNonPrepaid ?? [],

            [`${MANAGED_DATA_NETWORK_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${MANAGED_DATA_NETWORK_SERVICES_PREPAID}-which-of-the-following-features-do-you-intend-to-provide`]:
                managedDataNetworkServicesIntendToProvidePrepaid ?? [],

            [`${REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES}-plan-type`]:
                numberPortabilityCentralisedDatabaseServicesPlanTypeList(licenceDetails) ?? [],

            [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: docsLic ? docsLic : undefined
        }
    };
};

export const formatSBOIApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let shareholdersInformation = [];
    let SBOSNetwork = [];
    let targetCustomers = [];
    let boardOfDirectors = [];
    let boardOfDirectorsFromEDHACRA = [];
    let IPTelephonyServicesNonPrepaid = [];
    let IPTelephonyServicesPrepaid = [];
    let mobileVirtualNetworkOperationMeasureForEKYCNonPrepaid = [];
    let mobileVirtualNetworkOperationMeasureForEKYCPrepaid = [];
    let managedDataNetworkServicesIntendToProvideNonPrepaid = [];
    let managedDataNetworkServicesIntendToProvidePrepaid = [];

    shareholdersInformation = mapShareholdersInformation(licenceDetails);
    SBOSNetwork = mapSBONetwork(licenceDetails);
    targetCustomers = mapTargetCustomers(licenceDetails);
    boardOfDirectors = mapBoardOfDirectors(licenceDetails);
    boardOfDirectorsFromEDHACRA = mapBoardOfDirectorsFromACRA(licenceDetails);
    IPTelephonyServicesNonPrepaid = mapIPTelephonyServicesNonPrepaid(licenceDetails);
    IPTelephonyServicesPrepaid = mapIPTelephonyServicesPrepaid(licenceDetails);
    mobileVirtualNetworkOperationMeasureForEKYCNonPrepaid = mapMobileVirtualNetworkOperationMeasureForEKYCNonPrepaid(licenceDetails);
    mobileVirtualNetworkOperationMeasureForEKYCPrepaid = mapMobileVirtualNetworkOperationMeasureForEKYCPrepaid(licenceDetails);
    managedDataNetworkServicesIntendToProvideNonPrepaid = mapManagedDataNetworkServicesIntendToProvideNonPrepaid(licenceDetails);
    managedDataNetworkServicesIntendToProvidePrepaid = mapManagedDataNetworkServicesIntendToProvidePrepaid(licenceDetails);

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'services-based-operations-individual-licence',
        formID: 'services-based-operations-individual-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${SHAREHOLDERS_INFORMATION}-list`]: shareholdersInformation ?? [],

            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-required-information-will-be-attached`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.requiredInformationWillBeAttached ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question1 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-one`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion1PleaseProvideDetails ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.question2 ?? '-',
            [`${STRUCTURE_OF_ACRA_ENTITY_REGISTERED_INFORMATION}-if-yes-question-two`]:
                licenceDetails?.structureOfAcraEntityRegisteredInformation?.ifYesForQuestion2PleaseProvideDetails ?? '-',

            [`${FINANCIAL_INFORMATION}-required-information-will-be-attached`]:
                licenceDetails?.financialInformationPAGE?.requiredInformationWillBeAttached ?? '-',
            [`${FINANCIAL_INFORMATION}-financial-details`]: licenceDetails?.financialInformationPAGE?.financialDetails ?? '-',
            [`${FINANCIAL_INFORMATION}-financial-from`]: licenceDetails?.financialInformationPAGE?.financialYearFrom ?? '-',
            [`${FINANCIAL_INFORMATION}-financial-to`]: licenceDetails?.financialInformationPAGE?.financialYearTo ?? '-',

            [`${MEANS_THROUGH_WHICH_USERS_GAIN_ACCESS_TO_SBO_NETWORK}-means-through-which-users-gain-access-to-sbos-network`]:
                SBOSNetwork ?? [],

            [`${COLLECTION_OF_PAYMENT}-collection-of-monetary-deposits-or-use-of-prepaid-cards`]:
                licenceDetails?.collectionOfPayment?.collectionOfMonetaryDepositsOrUseOfPrepaidCards ?? '-',

            [`${DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED}-please-attached-required-information`]:
                licenceDetails?.descriptionOfProposedServiceAndMarketServed?.pleaseAttachRequiredInformation ?? '-',
            [`${DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED}-proposed-service-and-market-served-details`]:
                licenceDetails?.descriptionOfProposedServiceAndMarketServed?.proposedServiceAndMarketServedDetails ?? '-',
            [`${DESCRIPTION_OF_PURPOSED_SERVICE_AND_MARKET_SERVED}-target-customers`]: targetCustomers ?? [],

            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-have-you-commenced-provision-operation-of-any-of-the-telecommunication-services-applied-for-in-this-application`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices
                    ?.provisioningOperationOfAnyOfTheTelecommunicationServices ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-please-state-the-date-of-commencement`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.pleaseStateTheDateOfCommencement ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-number-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.numberOfUsers ?? '-',
            [`${COMMENCEMENT_OF_PROVISION_AND_OR_OPERATION_OF_TELECOMMUNICATION_SERVICES}-profile-of-users`]:
                licenceDetails?.commencementOfProvisionAndOrOperationOfTelecommunicationServices?.profileOfUsers ?? '-',

            [`${SYSTEM_CONFIGURATION_AND_OPERATION}-required-information-will-be-attached`]:
                licenceDetails?.systemConfigurationAndOperation?.requiredInformationWillBeAttached ?? '-',

            [`${TELECOMMUNICATION_PARTNERS}-telecommunication-partners`]:
                licenceDetails?.telecommunicationPartners?.telecommunicationPartnersJSON ?? '-',

            [`${INTERNATIONAL_GATEWAYS}-international-gateways`]: licenceDetails?.internationalGateways?.internationalGatewaysJSON ?? '-',

            [`${OTHER_TECHNICAL_SUPPORT}-other-technical-support`]:
                licenceDetails?.otherTechnicalSupportPAGE?.otherTechnicalSupportJSON ?? '-',
            [`${OTHER_TECHNICAL_SUPPORT}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.otherTechnicalSupportPAGE?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${NUMBERING_REQUIREMENT}-numbering-requirement`]: licenceDetails?.numberingRequirementPAGE?.numberingRequirementJSON ?? '-',

            [`${INFORMATION_OF_BOARD_OF_DIRECTORS_CEO}-list`]: boardOfDirectors ?? [],

            [`${INFORMATION_OF_BOARD_OF_DIRECTORS_CEO_FROM_EDH_ACRA}-list`]: boardOfDirectorsFromEDHACRA ?? [],

            [`${REGISTRATION_FOR_PUBLIC_INTERNET_ACCESS_SERVICES}-plan-type`]:
                publicInternetAccessServicesPlanTypeList(licenceDetails) ?? [],

            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-wifi-connectivity`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.wiFiConnectivity ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-in-principal-approval`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.inPrincipleApproval ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-internet-services-company`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.internetServicesCompany ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_NON_PREPAID}-intention-to-charge-for-usage`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.NonPrepaid
                    ?.intentionToChargeForUsage ?? '-',

            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-wifi-connectivity`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid?.wiFiConnectivity ??
                '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-in-principal-approval`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.inPrincipleApproval ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-internet-services-company`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.internetServicesCompany ?? '-',
            [`${PUBLIC_INTERNET_ACCESS_SERVICES_PREPAID}-intention-to-charge-for-usage`]:
                licenceDetails?.servicesRegistered?.servicesList?.PublicInternetAccessServices?.planTypeList?.Prepaid
                    ?.intentionToChargeForUsage ?? '-',

            [`${REGISTRATION_FOR_OTHER_SERVICES}-plan-type`]: othersServicesPlanTypePlanTypeList(licenceDetails) ?? [],

            [`${OTHER_SERVICES_NON_PREPAID}-description`]:
                licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList?.NonPrepaid?.descriptionJSON ?? '-',

            [`${OTHER_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList?.Prepaid?.hotlineEnquiryNumberForPrepaidServices ??
                '-',
            [`${OTHER_SERVICES_PREPAID}-description`]:
                licenceDetails?.servicesRegistered?.servicesList?.Others?.planTypeList?.Prepaid?.descriptionJSON ?? '-',

            [`${REGISTRATION_FOR_RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES}-plan-type`]:
                resaleOfLocalLeaseFixedLineConnectivityServicesPlanTypeList(licenceDetails) ?? [],

            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID}-sbo-fbo-operator`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.NonPrepaid
                    ?.sboFboOperator ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID}-do-you-intend-to-resell-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.NonPrepaid
                    ?.doYouIntendToResellDarkFibre ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_NON_PREPAID}-activation-of-iru-or-lit-international-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.NonPrepaid
                    ?.activationOfIruOrLitInternationalDarkFibre ?? '-',

            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-sbo-fbo-operator`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.sboFboOperator ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-do-you-intend-to-resell-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.doYouIntendToResellDarkFibre ?? '-',
            [`${RESALE_OF_LOCAL_LEASED_FIXED_LINE_CONNECTIVITY_SERVICES_PREPAID}-activation-of-iru-or-lit-international-dark-fibre`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofLocalLeasedFixedlineConnectivityServices?.planTypeList?.Prepaid
                    ?.activationOfIruOrLitInternationalDarkFibre ?? '-',

            [`${REGISTRATION_FOR_INTERNATIONAL_CALLING_CARD_SERVICES}-plan-type`]:
                internationalCallingCardServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNATIONAL_CALLING_CARD_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalCallingCardServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES}-plan-type`]:
                whiteSpaceGeoLocationDatabaseServicesPlanTypeList(licenceDetails) ?? [],

            [`${WHITE_SPACE_GEO_LOCATION_DATABASE_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.WhiteSpaceGeoLocationDatabaseServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_IP_TELEPHONY_SERVICES}-plan-type`]: ipTelephonyServicesPlanTypeList(licenceDetails) ?? [],

            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-non-prepaid`]: IPTelephonyServicesNonPrepaid ?? [],
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-non-prepaid-others`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.nonPrepaidOthers ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-party-responsible-for-the-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.partyResponsibleForTheSubscriberRecords ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-storage-of-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.storageOfSubscriberRecords ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-maintenance-party-of-the-cdrs`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.maintenancePartyOfTheCdRs ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-cdrs-storage-in-singapore`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.cdRsStorageInSingapore ??
                '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-cdrs-retention-period`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid?.cdRsRetentionPeriod ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-manipulation-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.manipulationOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-passing-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.passingOnOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-masking-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.maskingOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-singapore-emergency-service-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.singaporeEmergencyServiceCentres ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${IP_TELEPHONY_SERVICES_NON_PREPAID}-authenticating-the-subscribers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.NonPrepaid
                    ?.authenticatingTheSubscribers ?? '-',

            [`${IP_TELEPHONY_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-prepaid`]: IPTelephonyServicesPrepaid ?? [],
            [`${IP_TELEPHONY_SERVICES_PREPAID}-prepaid-others`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.prepaidOthers ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-party-responsible-for-the-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.partyResponsibleForTheSubscriberRecords ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-storage-of-subscriber-records`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.storageOfSubscriberRecords ??
                '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-maintenance-party-of-the-cdrs`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.maintenancePartyOfTheCdRs ??
                '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-cdrs-storage-in-singapore`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.cdRsStorageInSingapore ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-cdrs-retention-period`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid?.cdRsRetentionPeriod ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-manipulation-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.manipulationOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-passing-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.passingOnOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-masking-of-calling-line-identity`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.maskingOfCallingLineIdentity ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-singapore-emergency-service-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.singaporeEmergencyServiceCentres ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${IP_TELEPHONY_SERVICES_PREPAID}-authenticating-the-subscribers`]:
                licenceDetails?.servicesRegistered?.servicesList?.IPTelephonyServices?.planTypeList?.Prepaid
                    ?.authenticatingTheSubscribers ?? '-',

            [`${REGISTRATION_FOR_VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY}-plan-type`]:
                voiceAndDataServicesWithMaskingOfCallingLineIdentityServicesPlanTypeList(licenceDetails) ?? [],

            [`${VOICE_AND_DATA_SERVICES_WITH_MASKING_OF_CALLING_LINE_IDENTITY_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VoiceAndDataServicesWithMaskingOfCallingLineIdentity?.planTypeList
                    ?.Prepaid?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_MACHINE_TO_MACHINE_SERVICES}-plan-type`]: machineToMachineServicesPlanTypeList(licenceDetails) ?? [],

            [`${MACHINE_TO_MACHINE_NON_PREPAID}-m2m-sim-card-providers-name`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.m2MSimCardProviderSName ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-local-mobile-telecommunication-operators`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.localMobileTelecommunicationOperators ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-mobile-country-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.mobileCountryCode ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-mobile-network-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.mobileNetworkCode ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-international-mobile-subscriber-identifier-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.internationalMobileSubscriberIdentifierNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-mobile-station-integrated-services-digital-network-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.mobileStationIntegratedServicesDigitalNetworkNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-m2m-devices-international-mobile-equipment-identity-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.m2MDevicesInternationalMobileEquipmentIdentityNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-do-you-intend-to-provide-physical-sim-cards-or-esims-or-both`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.doYouIntendToProvidePhysicalSimCardsOrESiMsOrBoth ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-are-the-sim-cards-and-or-esims-enabled-to-allow-voice-or-voip-calls`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.areTheSimCardsAndOrESiMsEnabledToAllowVoiceOrVoIpCalls ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-are-the-sim-cards-or-esims-enabled-to-contact-singapore-emergency-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.areTheSimCardsOrESiMsEnabledToContactSingaporeEmergencyCentres ?? '-',
            [`${MACHINE_TO_MACHINE_NON_PREPAID}-please-provide-the-country-that-the-m2m-data-will-be-stored-in`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.NonPrepaid
                    ?.pleaseProvideTheCountryThatTheM2MDataWillBeStoredIn ?? '-',

            [`${MACHINE_TO_MACHINE_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-m2m-sim-card-providers-name`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.m2MSimCardProviderSName ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-local-mobile-telecommunication-operators`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.localMobileTelecommunicationOperators ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-mobile-country-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid?.mobileCountryCode ??
                '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-mobile-network-code`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid?.mobileNetworkCode ??
                '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-international-mobile-subscriber-identifier-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.internationalMobileSubscriberIdentifierNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-mobile-station-integrated-services-digital-network-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.mobileStationIntegratedServicesDigitalNetworkNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-m2m-devices-international-mobile-equipment-identity-number-ranges`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.m2MDevicesInternationalMobileEquipmentIdentityNumberRanges ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-do-you-intend-to-provide-physical-sim-cards-or-esims-or-both`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.doYouIntendToProvidePhysicalSimCardsOrESiMsOrBoth ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-are-the-sim-cards-and-or-esims-enabled-to-allow-voice-or-voip-calls`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.areTheSimCardsAndOrESiMsEnabledToAllowVoiceOrVoIpCalls ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-are-the-sim-cards-or-esims-enabled-to-contact-singapore-emergency-centres`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.areTheSimCardsOrESiMsEnabledToContactSingaporeEmergencyCentres ?? '-',
            [`${MACHINE_TO_MACHINE_PREPAID}-please-provide-the-country-that-the-m2m-data-will-be-stored-in`]:
                licenceDetails?.servicesRegistered?.servicesList?.MachinetoMachineM2MServices?.planTypeList?.Prepaid
                    ?.pleaseProvideTheCountryThatTheM2MDataWillBeStoredIn ?? '-',

            [`${REGISTRATION_FOR_INTERNET_BASED_VOICE_AND_DATA_SERVICES}-plan-type`]:
                internetBasedVoiceAndDataServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.NonPrepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_NON_PREPAID}-authentication-method`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.NonPrepaid
                    ?.authenticationMethod ?? '-',

            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID}-please-provide-the-country-location-of-the-servers`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.Prepaid
                    ?.pleaseProvideTheCountryLocationOfTheServersIECPaaSSipEtc ?? '-',
            [`${INTERNET_BASED_VOICE_AND_DATA_SERVICES_PREPAID}-authentication-method`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetBasedVoiceAndDataServices?.planTypeList?.Prepaid
                    ?.authenticationMethod ?? '-',

            [`${REGISTRATION_FOR_INTERNATIONAL_SIMPLE_RESALE_SERVICES}-plan-type`]:
                internationalSimpleResaleServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNATIONAL_SIMPLE_RESALE_SERVICES_NON_PREPAID}-short-code-for-voice-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList?.NonPrepaid
                    ?.shortCodeForVoiceServices ?? '-',

            [`${INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${INTERNATIONAL_SIMPLE_RESALE_SERVICES_PREPAID}-short-code-for-voice-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternationalSimpleResaleServices?.planTypeList?.Prepaid
                    ?.shortCodeForVoiceServices ?? '-',

            [`${REGISTRATION_FOR_INTERNET_EXCHANGE_SERVICES}-plan-type`]: internetExchangeServicesPlanTypeList(licenceDetails) ?? [],

            [`${INTERNET_EXCHANGE_SERVICES_NON_PREPAID}-entity-peer`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList?.NonPrepaid?.entityPeer ?? '-',

            [`${INTERNET_EXCHANGE_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${INTERNET_EXCHANGE_SERVICES_PREPAID}-entity-peer`]:
                licenceDetails?.servicesRegistered?.servicesList?.InternetExchangeServices?.planTypeList?.Prepaid?.entityPeer ?? '-',

            [`${REGISTRATION_FOR_CALL_BACK_CALL_RE_ORIGINATION_SERVICES}-plan-type`]:
                callBackCallReOriginationServicesPlanTypeList(licenceDetails) ?? [],

            [`${CALL_BACK_CALL_RE_ORIGINATION_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.CallbackCallReoriginationServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES}-plan-type`]:
                storeAndRetrieveValueAddedServicesPlanTypeList(licenceDetails) ?? [],

            [`${STORE_AND_RETRIEVE_VALUE_ADDED_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.StoreandRetrieveValueAddedNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_STORE_AND_FORWARD_VALUE_ADDED_SERVICES}-plan-type`]:
                storeAndForwardValueAddedServicesPlanTypeList(licenceDetails) ?? [],

            [`${STORE_AND_FORWARD_VALUE_ADDED_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.StoreandForwardValueAddedNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES}-plan-type`]:
                satelliteMobileTelephoneOrDataServicesPlanTypeList(licenceDetails) ?? [],

            [`${SATELLITE_MOBILE_TELEPHONE_OR_DATA_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.SatelliteMobileTelephoneorDataServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES}-plan-type`]:
                resaleOfPublicSwitchedTelecommunicationServicesPlanTypeList(licenceDetails) ?? [],

            [`${RESALE_OF_PUBLIC_SWITCHED_TELECOMMUNICATION_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.ResaleofPublicSwitchedTelecommunicationServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_VIRTUAL_PRIVATE_NETWORK_SERVICES}-plan-type`]:
                virtualPrivateNetworkServicesPlanTypeList(licenceDetails) ?? [],

            [`${VIRTUAL_PRIVATE_NETWORK_SERVICES_NON_PREPAID}-vpn-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList?.NonPrepaid?.vpnServices ??
                '-',

            [`${VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${VIRTUAL_PRIVATE_NETWORK_SERVICES_PREPAID}-vpn-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.VirtualPrivateNetworkServices?.planTypeList?.Prepaid?.vpnServices ?? '-',

            [`${REGISTRATION_FOR_LIVE_AUDIOTEX_SERVICES}-plan-type`]: liveAudiotexServicesPlanTypeList(licenceDetails) ?? [],

            [`${LIVE_AUDIOTEX_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.LiveAudiotexServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES}-plan-type`]:
                mobileVirtualNetworkOperationServicesPlanTypeList(licenceDetails) ?? [],

            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-name-of-mobile-virtual-network-enabler`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.nameOfMobileVirtualNetworkEnabler ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-do-you-intend-to-provide-physical-sim-cards-and-or-esims`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.doYouIntendToProvidePhysicalSimCardsAndOrESiMs ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-know-your-customer-solution`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.knowYourCustomerEKycSolution ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-measures-for-ekyc-solution`]:
                mobileVirtualNetworkOperationMeasureForEKYCNonPrepaid ?? [],
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_NON_PREPAID}-delivery-and-activation-processes`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.NonPrepaid
                    ?.deliveryAndActivationProcesses ?? '-',

            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-name-of-mobile-virtual-network-enabler`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.nameOfMobileVirtualNetworkEnabler ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-do-you-intend-to-provide-physical-sim-cards-and-or-esims`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.doYouIntendToProvidePhysicalSimCardsAndOrESiMs ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-know-your-customer-solution`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.knowYourCustomerEKycSolution ?? '-',
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-measures-for-ekyc-solution`]:
                mobileVirtualNetworkOperationMeasureForEKYCPrepaid ?? [],
            [`${MOBILE_VIRTUAL_NETWORK_OPERATION_SERVICES_PREPAID}-delivery-and-activation-processes`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileVirtualNetworkOperation?.planTypeList?.Prepaid
                    ?.deliveryAndActivationProcesses ?? '-',

            [`${REGISTRATION_FOR_MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES}-plan-type`]:
                mobileCommunicationOnAircraftServicesPlanTypeList(licenceDetails) ?? [],

            [`${MOBILE_COMMUNICATION_ON_AIRCRAFT_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.MobileCommunicationsOnAircraft?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',

            [`${REGISTRATION_FOR_MANAGED_DATA_NETWORK_SERVICES}-plan-type`]: managedDataNetworktServicesPlanTypeList(licenceDetails) ?? [],

            [`${MANAGED_DATA_NETWORK_SERVICES_NON_PREPAID}-which-of-the-following-features-do-you-intend-to-provide`]:
                managedDataNetworkServicesIntendToProvideNonPrepaid ?? [],

            [`${MANAGED_DATA_NETWORK_SERVICES_PREPAID}-hotline-enquiry-number-for-prepaid-services`]:
                licenceDetails?.servicesRegistered?.servicesList?.ManagedDataNetworkServices?.planTypeList?.Prepaid
                    ?.hotlineEnquiryNumberForPrepaidServices ?? '-',
            [`${MANAGED_DATA_NETWORK_SERVICES_PREPAID}-which-of-the-following-features-do-you-intend-to-provide`]:
                managedDataNetworkServicesIntendToProvidePrepaid ?? [],

            [`${REGISTRATION_FOR_NUMBER_PORTABILITY_CENTRALISED_DATABASE_SERVICES}-plan-type`]:
                numberPortabilityCentralisedDatabaseServicesPlanTypeList(licenceDetails) ?? [],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };


    if (transactionType === 'Cancel') {
        licence = cancelLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication', docsLic);
    }

    if (transactionType === 'Renew') {
        licence = renewLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication');
    }

    if (transactionType === 'Amend') {
        licence = amendLicence(licenceDetails, 'IMDA-IRIS-Work-LICApplication', docsLic);
    }

    return licence;
};

const sboiPayloadApplication = {
    formatSBOIApplication
};

export default sboiPayloadApplication;
